<template>
    <div class="loader">
  <img src="@/assets/spinner.gif" class="loader-image" />
</div>
</template>

<script>
export default {
    name: 'spinner'
}
</script>

<style scoped>
.loader-image {
    width: 60px;
    height: 60px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    z-index: 9999;
}
</style>
